import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const GISMaps = () => {
    const pdfFiles = [
        "/DATA/Cyclone/GisMaps/Distict Map_DILI.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_AILEU.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_AINARO.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_BAUCAU.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_BOBONARO.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_COVALIMA.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_ERMERA.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_LAUTEM.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_LIQUICA.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_MANATUTO.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_MANUFAHI.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_OECUSSI.pdf",
        // "/DATA/Cyclone/GisMaps/Distict Map_VIQUEQUE.pdf",
    ];

    return (
        <div style={{ height: "100vh", width: "100%", overflowY: "auto" }}>
            {pdfFiles.map((pdfPath, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                        <Viewer fileUrl={pdfPath} />
                    </Worker>
                </div>
            ))}
        </div>
    );
};

export default GISMaps;